/* ============================================
   NODUS · WHATSAPP
   ============================================ */

if (!customElements.get('nodus-whatsapp')) {
	class NodusWhatsapp extends HTMLElement {
		connectedCallback() {
			this.toggleButton = this.querySelector('[data-nodus-whatsapp-toggle]');
			this.card = this.querySelector('[data-nodus-whatsapp-card]');

			if (!this.toggleButton || !this.card) return;

			this.handleToggle = this.toggle.bind(this);
			this.handleClose = this.close.bind(this);
			this.handleKeydown = this.onKeydown.bind(this);
			this.closeButton = this.querySelector('[data-nodus-whatsapp-close]');

			this.toggleButton.addEventListener('click', this.handleToggle);
			document.addEventListener('keydown', this.handleKeydown);

			if (this.closeButton) this.closeButton.addEventListener('click', this.handleClose);
		}

		disconnectedCallback() {
			if (this.toggleButton && this.handleToggle) {
				this.toggleButton.removeEventListener('click', this.handleToggle);
			}

			if (this.closeButton && this.handleClose) {
				this.closeButton.removeEventListener('click', this.handleClose);
			}

			if (this.handleKeydown) document.removeEventListener('keydown', this.handleKeydown);
		}

		toggle() {
			if (this.card.hidden) {
				this.open();
			} else {
				this.close();
			}
		}

		open() {
			this.card.hidden = false;
			this.toggleButton.setAttribute('aria-expanded', 'true');
		}

		close() {
			this.card.hidden = true;
			this.toggleButton.setAttribute('aria-expanded', 'false');
		}

		onKeydown(event) {
			if (event.key === 'Escape' && !this.card.hidden) {
				this.close();
				this.toggleButton.focus();
			}
		}
	}

	customElements.define('nodus-whatsapp', NodusWhatsapp);
}
